"use client";
import { jsxs as a, jsx as i } from "react/jsx-runtime";
const c = ({
  title: o,
  titleId: r,
  desc: l,
  descId: e,
  ...n
}) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-.5 -.5 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": e,
    ...n,
    children: [
      o ? /* @__PURE__ */ i("title", { id: r, children: o }) : null,
      l === void 0 ? /* @__PURE__ */ i("desc", { id: e, children: `
    Facebook F Streamline Icon: https://streamlinehq.com
  ` }) : l ? /* @__PURE__ */ i("desc", { id: e, children: l }) : null,
      /* @__PURE__ */ i("path", { d: "M5.2074 8.7432V14.85H8.538V8.7432h2.4835l.5168-2.808H8.5379V4.942c0-1.4844.5828-2.0529 2.0873-2.0529.468 0 .844.0115 1.0623.0345V.3768C11.2769.2648 10.272.15 9.692.15c-3.0692 0-4.4847 1.4499-4.4847 4.5765v1.2088H3.3125v2.8079z" })
    ]
  }
);
export {
  c as default
};
